/**
 * States of USA
 */

export const USA_STATES = [
	'', 'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL',
	'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME',
	'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH',
	'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI',
	'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY',
] as const;

export const CANADA_STATES = [
	'', 'AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT',
] as const;

export const CREDIT_SCORE_GOODNESS: {[id: string]: {[id: string]: number}} = {
	poor: {
		min: 300,
		max: 580,
	},
	fair: {
		min: 581,
		max: 670,
	},
	good: {
		min: 671,
		max: 740,
	},
	great: {
		min: 741,
		max: 800,
	},
	amazing: {
		min: 801,
		max: 850,
	},
};

export type stateCode = typeof USA_STATES[number];

export const PHONE_TYPES = ['', 'Cell', 'Home'];

export const UNITED_STATES = 'United States';
export const CANADA = 'Canada';

export const COUNTRIES = [
	'', UNITED_STATES,
];

export const SUFFIXES = [
	'', 'I', 'II', 'III', 'IV', 'V', 'JR', 'SR',
];

export const EDUCATION_TYPES: {[id: string]: string} = {
	0: '',
	1: '4-year college grad',
	2: '2-year college grad',
	3: 'Specialty training',
	4: 'Some college',
	5: 'High school grad',
	6: 'Not graduated',
	7: 'Unknown',
};

export const HOUSING_STATUSES = [
	'', 'Mortgage', 'Rent', 'Family', 'Own Outright', 'Military', 'Other',
];

export const EMPLOYMENT_STATUSES = [
	'', 'Full Time', 'Part Time', 'Retired', 'Military', 'Unemployed', 'Self Employed', 'Student', 'Other',
];

export const INCOME_TYPES = [
	'', 'Weekly', 'Bi-Weekly', 'Monthly', 'Annually',
];

export const MARITAL_STATUS = [
	'', 'Married', 'Unmarried', 'Separated',
];

export const STRIPE_ENABLED_COUNTRIES = [
	'United States',
];

export const PRICE_TYPES = {
	monthlyPriceType: 1,
	yearlyPriceType: 2,
};

export const AMPLITUDE_LABELS = {
	customizeDeal: 'CustomizeDeal',
	creditApplication: 'CreditApplication',
	creditScore: 'CreditScore',
	softPull: 'SoftPull',
	apply: 'Apply',
	vehicleInfo: 'VehicleInfo',
	dealDetails: 'DealDetails',
	protections: 'Protections',
	rebates: 'Rebates',
	saveDeal: 'SaveDeal',
	testDrive: 'TestDrive',
	tradeIn: 'TradeIn',
	dealProgress: 'DealProgress',
	dealProgressRedirect: 'DealProgressRedirect',
	payment: 'Payment',
	accessories: 'Accessories',
	nameOfCTA: 'NameOfCTA',
};

export const SEARCH_TYPE = {
	plate: 'plate',
	vin: 'vin',
	makeModel: 'makeModel',
};

export const STEP_STATUS = {
	completed: 'Completed',
	notCompleted: 'NotCompleted',
};

export const APPOINTMENT_TYPES = {
	TESTDRIVE_AT_DEALERSHIP: 2,
	TESTDRIVE_AT_CUSTOMER: 3,
};

export enum APPOINTMENT_REASONS {
	TESTDRIVE_AT_DEALERSHIP = 'Test Drive',
	TESTDRIVE_AT_CUSTOMER = 'Delivery',
	TESTDRIVE_AT_STORE = 'InStore',
}

export const ADVERTISED_OFFERS = {
	all: 1,
	loan: 2,
	lease: 3,
};

export const LENDERSOCKET_SERVICE_PROVIDER = {
	dealerTrack: 'DT',
	routeOne: 'R1',
};

export const VEHICLE_USAGE_TYPES: {[id: string]: string} = {
	0: '',
	1: 'Business',
	2: 'Agricultural',
	3: 'Hazardous',
	4: 'Local',
	5: 'Interstate',
	6: 'Intermediate',
	7: 'Personal',
};
